<template>
<div :class="['proScreen',isActive ? 'active':'',appData.SETTINGS.theme_name]" >
    <div class="proElements">

        <audio style="display:none;" id="menuSfx1" src="sfx/click2.mp3"></audio>        
        <!-- <div class="btnBack" @click="backToMenu()">Back to menu</div> -->        
        <!-- LOGO -->
        <div class="glTL">
            <!-- <div class="topBack"><img src="images/ui/btnBack.png" @click="backToMenu()"></div> -->
            <div class="topLogo">
                <img :src="proData.logo+'?V='+appData.SETTINGS.version" v-if="proData.logo && proData.logo.length>0" />
                <div class="topTitle" v-if="proData.logo.length==0">
                    {{proData.title}}
                </div>
                <div class="topDisc">
                  <span v-html="disclamerText"></span>
                </div>            
            </div>
        </div>
        
        <!-- ON DS THEME - DISPLAY DS LOGO TOP RIGHT CORNER -->
        <div class="glTR" v-if="appData.SETTINGS.theme_name=='ds'">
            <div class="topRightLogo">
                <img :src="'themes/'+appData.SETTINGS.theme_name+'/images/mainscreen_logo.svg'" /> 
            </div>
        </div>

        <!-- ON DS THEME - DISPLAY SLIDE NAME ON TOP MIDDLE 
        <div class="glTM" v-if="appData.SETTINGS.theme_name=='ds'">
            <div :class="['topMiddleTitle',topMiddleTitleCss]">
                {{topMiddleTitle}}
            </div>
        </div> -->

        <div class="glSidenote">
            <span v-if="showSidenote" v-html="getSidenote"></span>
        </div>

        <!-- Bottom left button (back arrow)-->
        <div class="glBL">
            <div class="btnBack"><img src="images/ui/btnBackDotted.png" @click="backToMenu()"></div>
        </div>

        <div :class="['infoBubble',showBubble===true ? 'active':'']">
            <span>{{localize('drag_to_rotate')}}</span>
        </div>

        <!-- graphics-layer circles fx -->
            <!-- <div class="glCentered glCircles">
            <img src="/images/circles_gx.png">
        </div>
        -->
        <!-- mid lines -->
         <!-- <div class="midLine1"></div><div class="midLine2"></div> -->

        <!-- ///// 3D MODEL FRAME ///// --> 
        <!--   
        <div :class="['glCentered glModel',showModel==true ? 'active' : '']">
            <iframe ref="modelFrame1" class="iframeViewer" :src="modelPath"></iframe>
        </div>
        -->
        <div id="glGallery1" :class="['glCentered glAnimation',showGalleryFrame==true ? 'active' : '']">
            <iframe class="iframeViewer" id="iframeGallery1" :src="galleryPath" ></iframe>
        </div>
        <!-- ////// animation layer ////// -->
        <div id="glAnimationFrame1" :class="['glCentered glAnimation',showAnimationFrame==true ? 'active' : '']">
            <iframe id="ifAnimation" :src="animationPath" ></iframe>
        </div>

        <!-- ////// video player ////// -->
        <div id="glVideo1" :class="['glCentered glVideo',showVideoWrapper==true ? 'active' : '']">
            <appvideo v-if="showVideoWrapper==true" :src="videoPath"></appvideo>
        </div>

        <!-- ////// image viewer ////// -->
        <div id="glImg1" :class="['glCentered glImage',showImageWrapper==true ? 'active' : '']">
            <appimg v-if="showImageWrapper==true" 
                :contentID="sectionElementData.content_id"
                :sectionData="sectionElementData"></appimg>            
        </div>

        <!-- ///// INT LINES ///// -->        
        <div class="navItems" v-if="useNavLines">
            <div class="aline" v-for="(item,index) in navLines" 
                :key="index" 
                :style="getLineStyle(item)">
                 <div class="dottedLine">
                    <img :style="getDotsLineStyle(item)" src="/images/svg/blueDotsLine.svg" >
                </div>
             </div>
            <div class="lineIcon" v-for="(item,spot_index) in navLines" 
                :key="spot_index" 
                :style="getLineSpotStyle(item)">
                <img @click="lineClicked(spot_index)" src="/images/svg/triangleBtn.svg">
                <span class="fname">Feature name</span>
             </div>
        </div>

        <!-- graphics-layer left centered .glLC .glText-->
        <!--
        <div class="glLC">
            <div class="glText">
                <typer :content="proData.content" :isActive="isTyperActive"></typer>
            </div>
        </div>
        -->

        <!-- ////// bottom product-menu ////// -->
        <div class="pmContainer">            
            <pmenu :elements="proData.elements" @onClick="onMenuClick"></pmenu>
        </div>

    </div>    
  </div>
</template>

<style>
    .glSidenote
    {
        width: 27vw;        
        text-align: left;
    }
    .glSidenote span
    {
        font-style: italic;
        font-size: 10px;
        line-height: 11px;
        opacity: 0.5;
        text-align: left;
        display: block;        
    }
    .glSidenote span a
    {
        line-height: 11px;
        font-size: 10px;
        color:#16a5e6 !important;
    }

    .topDisc span a
    {
        color:#16a5e6 !important;
    }
</style>
<style scoped>
    .pmContainer
    {
        position: fixed;
        bottom: 3vw;
        left: 50vw;
        transform: translate(-50%,0%);
        z-index: 1000;        
    }
    .proScreen
    {
        opacity: 0;
        transition: all ease 0.5s;
        position: relative;
    }
    .proScreen
    {
        font-family: Arial, Helvetica, sans-serif;
    }
    .proScreen.ds
    {
        font-family: "Montserrat", sans-serif !important;
    }

    .proScreen.active
    {
        opacity: 1;
    }
    .proScreen .proElements
    {
        color: #fff;
        margin: auto;
        text-align: center;
    }
    /* aligned styles */
    .glCentered
    {
        position: absolute;
        top: 50vh;
        left: 50vw;
        transform: translate(-50%,-50%);
    }
    .glTL
    {
        position: fixed;top: 3vw;left: 3vw;z-index: 2000;
    }
    .glTR
    {
        position: fixed;top: 3vw;right: 3vw;z-index: 2000;
    }
    .glBL
    {
        position: fixed;bottom: 3vw;left: 3vw;z-index: 2000;
    }
    .glSidenote
    {
        position: fixed;
        bottom: calc(3vw + 100px);
        left: 3vw;z-index: 1900;
    }
    .glTM
    {
        position: fixed;
        top: calc(3vw - 1px);
        left: 50VW;        
        transform: translateX(-50%);
        width: 50vw;
    }

    .glLC
    {
        position: absolute;
        top: 50%;
        left: 3vw;
        transform: translateY(-50%);
    }
    .btnBack
    {
        float: left;
    }
    .btnBack img
    {
        width: 70px;
        height: 70px;
    }
    .topBack
    {
        float: left;
    }
    .topBack img
    {
        width: 4vh;
        height: 4vh;
    }
    .topLogo
    {
        float: left;
        /* padding-left: 10px; */
    }
    .topLogo img
    {
        float: left;
        width: auto;
        height: 4vh;
    }
    .topTitle
    {
        text-align:left;
        font-size: 16px;
    }
    .topMiddleTitle
    {
        text-align:center;
        font-size: 24px;
        color: #fff;
        opacity:0;
        transition: all ease 0.4s;
    }
    .topMiddleTitle.active
    {
        opacity:0.7;
    }

    .topDisc
    {
        clear: both;
        display: block;
        width: 350px;
        text-align: left;    
        padding-top: 1.3vw;            
    }
    .topDisc span
    {
        font-style: italic;
        font-size: 11px;
        opacity: 0.6;
    }
    .topDisc span a
    {
        color:#16a5e6 !important;
    }

    .topRightLogo
    {
        float: right;
        /* padding-left: 10px; */
    }
    .topRightLogo img
    {
        float: right;
        width: auto;
        height: 4vh;
    }

    .glCircles
    {
        z-index: 100;
        pointer-events: none;
    }
    .glCircles img
    {        
        height: 75vh;
        width: 75vh;
        max-width: 75vh;
        min-width: 75vh;
        max-height: 75vh;
        min-height: 75vh;
    }
    .glModel
    {
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        position: absolute;
        opacity: 0;
        transition: all ease 0.4s;
    }
    .glModel.active
    {
        opacity: 1;
    }
    .glModel iframe
    {
        width: 100vw;
        height: 100vh;
        /* border:solid 1px red; */
    }
    .glVideo
    {
        width: 110vh;
        height: 100vh;
        z-index: 1000;
        position: absolute;
        opacity: 0;
        transition: all ease 0.5s;
        display: flex;
        align-items: center;
        pointer-events: none;
    }
    .glVideo.active
    {
        opacity: 1;
        pointer-events: all;
    }    
    .glImage
    {
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        position: absolute;
        opacity: 0;
        transition: all ease 0.5s;
        display: flex;
        align-items: center;
        pointer-events: none;
    }
    .glImage.active
    {
        opacity: 1;
        pointer-events: all;
    }        
    .glAnimation
    {
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        position: absolute;
        opacity: 0;
        transition: all ease 0.5s;
        display: flex;
        align-items: center;
        pointer-events: none;
    }
    .glAnimation.active
    {
        opacity: 1;
        pointer-events: all;
    }    
    .glAnimation iframe
    {
        width: 100vw;
        height: 100vh;
        border:0px;
    }
    .glText
    {
        width: 25vw;
        text-align: left;
        font-weight: 100;
        font-size: 2vh;
        line-height: 3vh;
        opacity: 0.9;
    }

    /* diagonal lines */
    .aline
    {
        position: absolute;
        top:50vh;left: 0px;
        width: 100vw;height: 50px;
        transform: translateY(-50%) rotate(var(--rot));
        transform-origin: center center;
        cursor: pointer;
        transition: all ease 0.8s;
    }
    .dottedLine
    {
        position: relative;
        left: calc(50% + 25.5vh);
        top:25px;height: 1px;
        width: 26vh;        
    }
    .dottedLine img
    {
        width:20vh;height:3px;
        position: absolute;
        top: 0px;left:0px;
        clip-path: inset(0 var(--clipinset) 0 0);
        transition: all ease 0.8s;
    }
    .lineIcon
    {        
        position: absolute;
        /* calc the location of the spot here */
        top:    calc(50vh + var(--iconY));
        left:   calc(50vw + var(--iconX));
        transition: all ease 0.8s;
    }
    .lineIcon img
    {
        width: 60px;height: auto;
        position: fixed;        
        z-index: 1000;
        transform: translate(-50%,-50%);
        transform-origin: center center;
        cursor: pointer;
        
    }
    .lineIcon .fname
    {
        position: relative;
        max-width: 50px;
        display: inline-block;
        left: -50%;
        top: 20px;
        font-size: 14px;
        font-weight: 100;
        color: #a3e4f4;
    }

    .iconText
    {
        display: none;
    }
    .midLine1
    {
        position: absolute;
        top:50vh;
        width: 100vw;
        height: 1px;
        background-color: red;
    }
    .midLine2
    {
        position: absolute;
        top:50vh;
        width: 100vw;
        height: 1px;
        background-color: red;
        transform: rotate(90deg);
    }
    .infoBubble
    {
        position: fixed;
        pointer-events: none;
        top: 50vh;
        left: calc(50vw + 80px);
        transform: translate(-50%,-50%) scale(0);
        width: 120px;
        height: 120px;
        border-radius: 100%;
        z-index: 5000;
        display: flex;        
        align-items: center;
        background: rgb(17,118,187);
        background: linear-gradient(56deg, rgba(17,118,187,0.3) 0%, rgba(24,160,194,0.7) 100%);
        transition: all 400ms cubic-bezier(.47,1.64,.41,.8);
    }
    .infoBubble.active
    {
        transform: translate(-50%,-50%) scale(1);
    }
    .infoBubble span
    {
        color: #fff;
        font-size: 15px;
        font-weight: 500;
        width: 80%;
        margin: auto;
        text-transform: uppercase;
    }

    /* CSS rules for tablets in portrait mode */
    @media only screen and (min-device-width: 601px) 
            and (max-device-width: 1024px) 
            and (orientation: portrait) 
    {
        .glTR
        {
            top: 3vw;right: 3vw;
        }
        .glTL{
            top: 4vw;left: 4vw;width: 100%;
        }
        .topLogo{
            float: none;width: 100%;
        }
        .topLogo img{
            float: none;width: auto;height: 4vh;margin: auto;
        }
    }

    /* CSS rules for smartphones in portrait mode */
    @media only screen and (max-device-width: 800px) and (orientation: portrait) 
    {
        .glModel iframe{
            transform: translateY(-30px);
        }
        .pmContainer{
            position: fixed;bottom: 0px;
        }
        .glTL {
            top: 20px;left: 0px;width: 100vw;text-align: center;
        }        
        .glTR
        {
            top: 5vw;right: 5vw;
        }
        .topRightLogo
        {
            display: none;
        }
        .topLogo{
            float:none;
            width: auto;
            position: fixed;
            left: 50vw;
            transform: translateX(-50%);   
            pointer-events: none;        
        }
        .topLogo img{
            float: none;height: 3.5vh;margin: auto;display: inline-block;
        }        
        .glBL{
            top: 20px;left: 20px;
            height: 80px;
        }
        .btnBack img{
            width: 40px;height: 40px;
        }        
        .topTitle
        {
            text-align: center;
            position: relative;
            top: 10px;
            font-size: 14px;
        }
    }
</style>

<script>
    import Typer from "@/components/typer.vue";  
    import Proscreenmenu from "@/components/Proscreenmenu.vue";  
    import AppVideo from "@/components/AppVideo.vue";  
    import AppImage from "@/components/appImage.vue";  
    //import Screen from "@/components/Screen.vue";
    import { mapState } from "vuex";
    export default 
    {
        components:
        {
            typer:Typer,
            pmenu:Proscreenmenu,
            appvideo:AppVideo,
            appimg:AppImage
        }, 
        computed:
        {
            ...mapState(["appData"]),
            getSidenote()
            {
                //get the sidenote for a specific slide index in the product 
                var productIndex = this.product;
                var productData = this.getCurrentSectionData();// this.appData.SECTIONS[productIndex];
                var elementData = productData.elements[this.navCurrentIndex];
                if(elementData.sidenote){
                    return elementData.sidenote;
                }
                return "";

            },
            disclamerText()
            {
                var productIndex = this.product;
                var productData = this.getCurrentSectionData();// this.appData.SECTIONS[productIndex];
                var elementData = productData.elements[this.navCurrentIndex];
                if(productData.disclamer){
                    return productData.disclamer;
                }
                return "";
            },
            modelPath()
            {
                var productIndex = this.product;
                var productData = this.getCurrentSectionData();//this.appData.SECTIONS[productIndex];
                var elementData = productData.elements[this.navCurrentIndex];
                var modelFileName = elementData.file;// "model_"+productData.name+".html";
                if(this.setEmptyIframe==true){
                    return "_clear.html";//keep the iframe clear
                }
                return modelFileName;
            },
            sectionElementData()
            {
                var productIndex = this.product;
                var productData = this.getCurrentSectionData();//this.appData.SECTIONS[productIndex];
                var elementData = productData.elements[this.navCurrentIndex];
                return elementData;
            },
            videoPath()
            {
                var productIndex = this.product;
                var productData = this.getCurrentSectionData();//this.appData.SECTIONS[productIndex];
                var elementData = productData.elements[this.navCurrentIndex];
                if(elementData.files && elementData.files.length>0)
                {
                    var modelFileName = elementData.files[0].file;// "model_"+productData.name+".html";
                    return modelFileName;
                }
                return false;
            }
        },
        data()
        {
            return {
                topMiddleTitleCss:'',
                topMiddleTitle:'',
                _iframeModelViewer1:null,
                _menuSfx1:null,
                sound2:null,
                useNavLines:false,
                showModel:false,
                setEmptyIframe:false,
                showVideoWrapper:false,
                showImageWrapper:false,
                showAnimationFrame:false,
                showGalleryFrame:false,
                showSidenote:false,
                animationPath:'',
                galleryPath:'',
                showVideo:false,
                navCurrentIndex:0,
                showBubble:false,
                showBubbleCount:0,
                navLines:[
                    {rotate:-25,maskVal:80, iconX:0,iconY:'0px'},
                    {rotate:18,maskVal:55,  iconX:110,iconY:'110px'},
                    {rotate:45,maskVal:75, iconX:220,iconY:'220px'},
                ],
                proData:[],
                isActive:false,
                isTyperActive:false,
                thecontent:'The conical, root-shaped geometry of the LANCE+ and its variable threads are designed to enable excellent primary stability - offering the ultimate choice for a wide range of clinical cases and loading protocols LANCE+ also features a triple thread geometry which increases the implant insertion rate (2.25mm), allowing for a simpler and faster implant placement.'
            }
        },
        created()
        {
            this.setScreenHeight();
        },
        mounted()
        {
            var vm=this;
            if (window.addEventListener) {
                window.addEventListener("message", this.onMessage, false);        
            } 
            else if (window.attachEvent) {
                window.attachEvent("onmessage", this.onMessage, false);
            }

            var productIndex = this.product;
            //this.proData = this.appData.SECTIONS[productIndex];            
            //Get the product data by it's name and not index:
            this.proData = this.getCurrentSectionData();// this.appData.SECTIONS.filter(x => x.name === this.product_id)[0];
            this.showCurrentElement();
            //this.showCurrentTopTitle();

            setTimeout(() => {
                //this.sound2.play();
                this._menuSfx1 = document.getElementById("menuSfx1");
                this.isActive=true;
                this.isTyperActive = true;
            }, 400);

            this._iframeModelViewer1 = document.getElementById("iframeModelViewer1");
            window.onresize = function() {
                vm.setScreenHeight();
            };
            vm.setScreenHeight();

/*             var _ifAnimation = document.getElementById("ifAnimation");
            _ifAnimation.addEventListener( "load", function(e) 
            {                
                vm.showAnimationFrame = true;//alert("animation loaded");
            } );
 */

        },
        props:
        {
            product:{
                default:0,
                type:Number
            },
            product_id:{
                default:"",//product_id is the uniq name from the json data (seven,c1,etc....)
                type:String
            }

        },
        watch:
        {
            navCurrentIndex:function(newVal,oldVal)
            {
                //alert(this.navCurrentIndex);
                if(newVal==0)
                {
                    //show implant model
                    //(reload the iframe url)
                }
                else if(newVal==1)
                {
                    //show kit model
                    //(reload the iframe url)
                }

            }
        },
        methods:
        {
            getCurrentSectionData()
            {
                //let secData = getCurrentSectionData();// this.appData.SECTIONS[productIndex];
                return  this.appData.SECTIONS.filter(x => x.name === this.product_id)[0];
            },
            
            getCountryCode()
            {
                var winLoc = window.location.href;
                var urlParts = winLoc.split("/");
                var countryCode = "";
                if(urlParts.length>0){
                    var lastUrlPart = (urlParts[urlParts.length - 1]);
                    if(lastUrlPart.length==2){
                    countryCode = lastUrlPart;
                    }
                }
                return countryCode;
            },           
            localize(tag)
            {
                let tagText = tag.toLowerCase().replace(/(\s|-)/g, "_");
                let obj = this.appData.UI.find(({ tag }) => tag === tagText);
                if (obj) {return obj.title;}
                return tag;
            },
            setScreenHeight()
            {
                var viewportHeight = window.innerHeight || document.documentElement.clientHeight;          
                //if(window.innerWidth<1000)
                //{
                    let glAnimationFrame1 = document.getElementById("glAnimationFrame1");
                    let glVideo1 = document.getElementById("glVideo1");
                    let glGallery1 = document.getElementById("glGallery1");
                    
                    glAnimationFrame1.style.height = viewportHeight + "px";
                    glVideo1.style.height = viewportHeight + "px";
                    glGallery1.style.height = viewportHeight + "px";

                    this._iframeModelViewer1.style.height = viewportHeight + "px";
                //}
            },
            isModelHasHotSpots()
            {
                var productIndex = this.product;
                let secData = this.getCurrentSectionData();// this.appData.SECTIONS[productIndex];
                var curElementData = secData.elements[this.navCurrentIndex];
                if(curElementData.has_hotspots!="true"){
                    return false;
                }
                return true;
            },
            onMessage(event) 
            {
                // Check sender origin to be trusted
                
                //if (event.origin !== "http://example.com") return;
                var data = event.data;
                console.log("data.message="+data.message);

                if(data.message=='model_loaded')
                {
                    if(this.isModelHasHotSpots())
                    {
                        setTimeout(() => {
                            //this.sfxPlay("open1");
                        }, 500);                    
                    }
                    this.showModelBubble();
                }                
                if(data.message=='model_change_func')
                {
                    //not working
                    /////alert("got function from child : data.func="+data.func);
                }
            },
            showModelBubble()
            {
                if(this.showBubbleCount==0)
                {
                    setTimeout(() => {                
                        this.showBubble=true;
                    }, 1000);
                    setTimeout(() => {
                        this.showBubble=false;
                    }, 4000);
                    this.showBubbleCount++;
                }
            },
            onMenuClick(index)
            {
                var vm = this;
                if(index!=this.navCurrentIndex)
                {
                    //vm.showModel=false;//hide the 3d model
                    vm.fadeout3DModel();
                    vm.showVideoWrapper = false;        //hide video                        
                    vm.showImageWrapper = false;        //hide image                        
                    vm.showAnimationFrame = false;      //hide animation layer                    
                    vm.showGalleryFrame = false;        //hide video gallery swiper frame
                    vm.showSidenote = false;            //<<========================================
                    
                    vm.galleryPath = "_clear.html";

                    //vm.showCurrentTopTitle();//replace the top middle title

                    setTimeout(() =>
                    {                        
                        vm.setEmptyIframe = true;//reset the iframe
                    }, 500);
                    setTimeout(() => 
                    {
                        vm.navCurrentIndex = index;
                        vm.showCurrentElement();
                        //vm.showModel=true;//show the 3d model after 2 seconds
                    }, 1200);
                }
            },
            fadeout3DModel()
            {
                let modelLayer = document.getElementById("modelFrameWrapper1");
                modelLayer.classList.remove("active");
            },
            fadein3DModel()
            {
                let modelLayer = document.getElementById("modelFrameWrapper1");
                modelLayer.classList.add("active");
            },
            showCurrentTopTitle()
            {
                var vm = this
                //var curElementData = vm.proData.elements[this.navCurrentIndex];
            },
            showCurrentElement()
            {
                //CHECK LOTTIE ANIMATION SCREEN 
                //CHECK IF WE NEED MULTIPLE VIDEOS FOR EACH SECTION
                var vm = this
                var curElementData = vm.proData.elements[this.navCurrentIndex];
                vm.setEmptyIframe = false;

                //CHANGE TOP MIDDLE TITLE
                vm.topMiddleTitleCss = "";//fadeout element
                setTimeout(() => {vm.topMiddleTitle= "";}, 500);
                if(curElementData.top_title && curElementData.top_title.length>0)
                {                    
                    setTimeout(() => {
                        vm.topMiddleTitle= curElementData.top_title;
                        vm.topMiddleTitleCss = "active";
                    }, 1000);                    
                }

                //CHANGE MODEL
                let iframeForModel = document.querySelector('#iframeModelViewer1');
                if(curElementData.mode=='3d')
                {                    
                    vm.showSidenote = true;
                    vm.showModel = true;                                        
                    //replace the model by chananging the iframe url hash:
                    let modelID = this.getModelID();                    

                    //todo:
                    //instead of sending the hash, try to create a global event and send 
                    //the modelID and also the main site id (lynx/ds/etc/....)
                    //var _appID = e.detail.appID;
                    //var _themeID = e.detail.themeID;

                    //todo:
                    //appData.SETTINGS.app_name (folder)//<<<<add to all main data files or get from the main app.vue file
                    const event = new CustomEvent('onModelChanged', {
                        detail: 
                        {
                            modelID:    modelID,
                            appID:      this.appData.SETTINGS.app_id,
                            themeID:    this.appData.SETTINGS.theme_name
                        },
                        bubbles:true,
                        cancelable: true});
                        window.dispatchEvent(event);

                        //window.parent.postMessage({'message': 'preloading_complete'}, "*");
                        //on the modelV3.html page:
                        //window.addEventListener('onModelChanged',this.onModelChanged);                    
                        //let iframeForModel = document.querySelector('#iframeModelViewer1');

                    const modelChangeData = {
                        type: 'onModelChangeEvent',
                        detail: { 
                            modelID:    modelID,
                            appID:      this.appData.SETTINGS.app_id,
                            themeID:    this.appData.SETTINGS.theme_name
                        }
                    };
                    iframeForModel.contentWindow.postMessage(modelChangeData, '*'); // or use iframe.src origin instead of '*'
                    iframeForModel.contentWindow.location.hash = modelID;
                    setTimeout(() => {
                        this.fadein3DModel();
                    }, 500);
                }
                else 
                {
                    iframeForModel.contentWindow.location.hash = "none";
                }
                if(curElementData.mode=='video')
                {
                    vm.showVideoWrapper = true;
                }                
                if(curElementData.mode=='image')
                {
                    vm.showImageWrapper = true;
                }                

                if(curElementData.mode=='animation')
                {
                    //vm.addAnimationFrame("animation.html?animation_name="+curElementData.file_id);
                    vm.animationPath = "animation.html?animation_name="+curElementData.file_id;
                    //the animation will be set to visible when the iframe onLoad is fired
                    //this is to prevent empty white frame when loading the page into the iframe
                    setTimeout(() => {
                        vm.showAnimationFrame = true;    
                    }, 750);
                    
                }
                if(curElementData.mode=='magnify')
                {
                    //vm.addAnimationFrame("magnify.html?image_name="+curElementData.file_id);
                    vm.animationPath = "magnify.html?image_name="+curElementData.file_id;
                    //the animation will be set to visible when the iframe onLoad is fired
                    //this is to prevent empty white frame when loading the page into the iframe
                    setTimeout(() => {
                        vm.showAnimationFrame = true;    
                    }, 750);

                }
                if(curElementData.mode=='swiper')
                {
                    let cc = this.getCountryCode();
                    let sectionIndex = this.product;
                    let elementIndex = this.navCurrentIndex;
                    vm.galleryPath = "swiper.html?cc="+cc+"&section="+sectionIndex+"&element="+elementIndex;
                    vm.showGalleryFrame = true;
                }

            },
            addAnimationFrame(url)
            {

                /*<div id="glAnimationFrame1" :class="['glCentered glAnimation',showAnimationFrame==true ? 'active' : '']">
                    <iframe id="ifAnimation" :src="animationPath"></iframe>
                </div>
                */
                //if frame exists then remove it

                //add frame to 

                
                //vm.animationPath = "animation.html?animation_name="+curElementData.file_id;
                //the animation will be set to visible when the iframe onLoad is fired
                //this is to prevent empty white frame when loading the page into the iframe
                //vm.showAnimationFrame = true;

            },

            getModelID()
            {
                var productIndex = this.product;
                var productData = this.getCurrentSectionData();// this.appData.SECTIONS[productIndex];
                var elementData = productData.elements[this.navCurrentIndex];
                var mid = elementData.model_id;
                return mid;
            },
            lineClicked(index)
            {
                var vm=this;
                // show kit if clcked on 2nd item
                // show implant if clicked 1st
                if(index!=this.navCurrentIndex)
                {
                    vm.showModel=false;//hide the 3d model
                    vm.navCurrentIndex = index;
                    setTimeout(() => {
                        vm.showModel=true;//show the 3d model after 2 seconds
                    }, 2500);
                }

                for(var i=0;i<this.navLines.length;i++)
                {
                    if(i==index){
                        this.navLines[i].maskVal = 100;
                        //this.navLines[i].rotate = -25;
                        //item.rotate
                    }else{
                        //let rotateItem = Math.random() * (90 - 10) + 10
                        this.navLines[i].maskVal = 75;
                        //this.navLines[i].rotate = rotateItem;
                    }
                }
                //{rotate:-25,width:20,   maskVal:50, iconX:0,iconY:'0px'}/,
            },
            getLineSpotStyle(item)
            {
                let scrH = screen.height;
                let startRadius = ((scrH/100)*25.5) - 30;
                let maxRadius = ((scrH/100)*20);//20VH is the max length
                let addRadius =  ((maxRadius/100)*item.maskVal);
                let totalRadius = startRadius+addRadius;

                //{rotate:18,width:20,    maskVal:80, iconX:110,iconY:110},
                //var radius = 300;//item.maskVal; <<<< todo: calc base distance by screen height 
                var radius =  totalRadius;//(scrH/100)*25.5 + ((scrH/100)*20)*item.maskVal;
                var angle  = item.rotate + 90;
                item.iconX=(radius*Math.cos((angle+(-90))*(Math.PI/180)));
                item.iconY=(radius*Math.sin((angle+(-90))*(Math.PI/180)));
                return '--iconX:'+item.iconX+"px;--iconY:"+item.iconY+'px';
            },
            getDotsLineStyle(item)
            {
                let maskSize = 100-item.maskVal; //the mask precentage of the dots
                return '--clipinset:'+maskSize+'%';
            },
            getLineIconStyle(item)
            {            
                let iconDeg = item.rotate * -1;
                return '--rot:'+iconDeg+'deg';
            },
            getLineStyle(item)
            {
                return '--rot:'+item.rotate+'deg';
            },
            backToMenu()
            {
                this.isActive = false;
                this.fadeout3DModel();

                //this._menuSfx1.play();
                this.sfxPlay("Interface_2");

                setTimeout(() => {
                    this.$emit("onCloseProduct");
                }, 400);                
            },
            openItem(index)
            {
                //this.$emit('onClick',index);
            }
        }
    };
</script>